import { ssrApi } from 'api/ssr';
import { BlogAndNewsPage } from 'components/template/blogs-and-news-page';
import { IBlogPost } from 'constants/types';
import { ParsedUrlQuery } from 'querystring';

export default function Blogs({
  posts,
  topPosts,
  category,
}: {
  posts: IBlogPost[];
  topPosts: IBlogPost[];
  category: string;
}) {
  return (
    <BlogAndNewsPage posts={posts} topPosts={topPosts} category={category} />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { category } = query;

  const { results: posts } = await ssrApi.blog.list({
    type: 'blogs-and-news',
    category: category?.toString(),
  });

  return {
    props: { posts, topPosts: [], category: category?.toString() },
  };
}
